var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 50,
    viewBox: "0 0 30 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 49,
    rx: 4.5,
    fill: "white",
    stroke: "#84A13D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55001 0.5H23.45C23.2184 1.64112 22.2095 2.5 21 2.5H9C7.79052 2.5 6.78164 1.64112 6.55001 0.5Z",
    fill: "white",
    stroke: "#84A13D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 16.5,
    width: 7,
    height: 7,
    rx: 0.5,
    fill: "white",
    stroke: "#84A13D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.5,
    width: 7,
    height: 7,
    rx: 0.5,
    fill: "white",
    stroke: "#84A13D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#84A13D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#84A13D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#84A13D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#84A13D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C16 30.4477 16.4477 30 17 30H18C18.5523 30 19 30.4477 19 31V32C19 32.5523 18.5523 33 18 33H17C16.4477 33 16 32.5523 16 32V31Z",
    fill: "#84A13D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 26.5,
    width: 7,
    height: 7,
    rx: 0.5,
    fill: "white",
    stroke: "#84A13D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9345502b4e9db8f482a57e08cee43daa.svg";
export { ForwardRef as ReactComponent };